import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Box, Group, Text, Textarea, TextInput, Divider, Select, Menu, ActionIcon, NativeSelect, Flex } from '@mantine/core';
import { IconPlus, IconX, IconDotsVertical } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils } from "../../utils/globalVariables";
import { safeValue, changeValueOfArrayImmutable, removeFromArrayByIndex, arrayObjectToStringWithDivider, isEmptyArrayObject } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import ModalTakeActionWithFooterWhenHasData from "../../components/general/ModalTakeActionWithFooterWhenHasData";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import InputComponent from "../../components/general/InputComponent";

import PaperWrapper from "../../components/utilities/PaperWrapper";

import SedangJemputFoto from "./SedangJemputFoto";

const ComponentBarangActual = ({
    dataDataKey,
    dataCategoryBarang,
    stateKey,
    stateCustomerId,
    utilsRef,
    fnCloseDrawer,
    fnBarangPackage,
    fnBarang,
    fnBarangDelete,
    fnChangeFoto,
    fnClickPhoto
}) => {

    const mountedRef = React.useRef(true);

    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorBarangPackage: 'componentBarangActual-4',
        errorBarang: 'componentBarangActual-4-1',
        errorBarangDelete: 'componentBarangActual-4-2',

        errorGetSuggestionBarangName: 'componentBarangActual-5',
        errorGetSuggestionBarangNameEdit: 'componentBarangActual-6',
    })

    const canEditBarangActual = React.useRef([
        utils.penjemputanSteps.nota.value,
        utils.penjemputanSteps.segera_menjemput.value,
        utils.penjemputanSteps.sedang_menjemput.value,
    ])

    const constKelengkapan = {
        name: ''
    }

    const constKelengkapanEdit = {
        delivery_jemput_kelengkapan_actual_name: ''
    }

    const [data, setData] = React.useState({
        barang: {
            barangModal: false,
            barangLoadingSubmit: false,

            masterId: '',
            stateKey: '',

            barangCategorySelected: '',
            barangCategorySelectedError: '',

            suggestModal: false,
            suggestLoadingInit: false,
            suggestData: [],
            suggestSelected: '',

            barangName: '',
            barangNameError: '',

            kelengkapan: [],
            kelengkapanError: '',
            keluhan: ''
        },

        editBarang: {
            modal: false,
            submitLoading: false,
            masterId: '',
            primaryKeyId: '',
            stateKey: '',

            barangCategorySelected: '',
            barangCategorySelectedError: '',

            suggestModal: false,
            suggestLoadingInit: false,
            suggestData: [],
            suggestSelected: '',

            barangName: '',
            barangNameError: '',

            kelengkapan: [],
            kelengkapanError: '',

            keluhan: ''
        },

        deleteBarang: {
            modal: false,
            submitLoading: false,
            trxId: '',
            primaryKeyId: '',
            stateKey: '',
        },

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const fnGetSuggestNamaBarang = React.useCallback(({
        stateData,
        fnSetDataLoading,
        fnIsSet,
        fnErrorGetData,
    }) => {
        fnSetDataLoading(true);

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('barang_category_selected', stateData.barangCategorySelected);
        formDT.append('customer_id', stateCustomerId);
        formDT.append('project_process_sudah_diambil', utils.projectProcess.sudah_diambil.value);

        axios({
            method: 'post',
            url: BE_API_THREE + '/get_suggestion_barang_name',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            fnSetDataLoading(false);

            if (response.data.flag_status === 'isset') {
                fnIsSet({
                    responseData: response.data.data,
                    suggestSelected: ''
                });
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            fnSetDataLoading(false);
            fnErrorGetData(error.message);
        })
    }, [handleSetLoginContext, loginContext, stateCustomerId])

    React.useEffect(() => {
        fnGetSuggestNamaBarang({
            stateData: {
                barangCategorySelected: data.barang.barangCategorySelected,
                customerId: stateCustomerId
            },
            fnSetDataLoading: (val) => {
                setData(d => ({ ...d, barang: { ...d.barang, suggestLoadingInit: val } }));
            },
            fnIsSet: (obj) => {
                setData(d => ({
                    ...d,
                    barang: {
                        ...d.barang,
                        suggestData: obj.responseData,
                        suggestSelected: obj.suggestSelected,
                    },
                }))
            },
            fnErrorGetData: (val) => {
                notifications.show({
                    id: notificationId.current.errorGetSuggestionBarangName,
                    title: utils.notification.warning.caption,
                    message: val,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }
        });
    }, [fnGetSuggestNamaBarang, data.barang.barangCategorySelected, stateCustomerId])

    React.useEffect(() => {
        fnGetSuggestNamaBarang({
            stateData: {
                barangCategorySelected: data.editBarang.barangCategorySelected,
                customerId: stateCustomerId
            },
            fnSetDataLoading: (val) => {
                setData(d => ({ ...d, editBarang: { ...d.editBarang, suggestLoadingInit: val } }));
            },
            fnIsSet: (obj) => {
                setData(d => ({
                    ...d,
                    editBarang: {
                        ...d.editBarang,
                        suggestData: obj.responseData,
                        suggestSelected: obj.suggestSelected,
                    },
                }))
            },
            fnErrorGetData: (val) => {
                notifications.show({
                    id: notificationId.current.errorGetSuggestionBarangNameEdit,
                    title: utils.notification.warning.caption,
                    message: val,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }
        });
    }, [fnGetSuggestNamaBarang, data.editBarang.barangCategorySelected, stateCustomerId])

    React.useEffect(() => {
        if (Array.isArray(data.barang.kelengkapan) && data.barang.kelengkapan.length <= 0) {
            setData(d => ({ ...d, barang: { ...d.barang, kelengkapanError: '' } }));
        }
    }, [data.barang.kelengkapan]);

    const submitTambahBarang = () => {
        setData(d => ({ ...d, barang: { ...d.barang, barangNameError: '', barangCategorySelectedError: '', kelengkapanError: '' } }));

        if (validator.isEmpty(data.barang.barangCategorySelected, { ignore_whitespace: true })) {
            setData(d => ({ ...d, barang: { ...d.barang, barangCategorySelectedError: 'Pilih Kategori Barang Terlebih Dahulu.' } }))
        } else if (validator.isEmpty(data.barang.barangName, { ignore_whitespace: true })) {
            setData(d => ({ ...d, barang: { ...d.barang, barangNameError: 'Nama Barang Wajib Diisi.' } }))
        } else if (isEmptyArrayObject(data.barang.kelengkapan, 'name')) {
            setData(d => ({ ...d, barang: { ...d.barang, kelengkapanError: 'Lengkapi list kelengkapan terlebih dahulu atau hapus item yang kosong!' } }))
        } else {
            setData(d => ({ ...d, barang: { ...d.barang, barangLoadingSubmit: true } }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('master_id', data.barang.masterId);
            formDT.append('current_step', utilsRef.currentStep);
            formDT.append('is_cancel', utilsRef.isCancel);

            formDT.append('barang_category', data.barang.barangCategorySelected);
            formDT.append('barang_name', data.barang.barangName);
            formDT.append('barang_keluhan', data.barang.keluhan);
            formDT.append('barang_kelengkapan_array', JSON.stringify(data.barang.kelengkapan));

            axios({
                method: 'post',
                url: BE_API_THREE + '/update_delivery_penjemputan__barang_package_actual',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, barang: { ...d.barang, barangLoadingSubmit: false, barangModal: false } }));

                if (response.data.flag_status === 'isset') {
                    fnBarangPackage(data.barang.stateKey, 'barang', response.data.data);

                    setData(d => ({
                        ...d,
                        barang: {
                            ...d.barang,
                            masterId: '',
                            stateKey: '',

                            barangCategorySelected: '',
                            barangName: '',

                            suggestData: [],
                            suggestSelected: '',

                            keluhan: '',
                            kelengkapan: [],
                        },
                    }))
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorBarangPackage,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data') {
                    // fnCloseDrawer();

                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data tidak ditemukan.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, barang: { ...d.barang, barangLoadingSubmit: false, barangModal: false } }));

                notifications.show({
                    id: notificationId.current.errorBarangPackage,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }

    const submitUpdateBarang = () => {
        setData(d => ({ ...d, editBarang: { ...d.editBarang, barangNameError: '', barangCategorySelectedError: '', kelengkapanError: '' } }));

        if (validator.isEmpty(data.editBarang.barangCategorySelected, { ignore_whitespace: true })) {
            setData(d => ({ ...d, editBarang: { ...d.editBarang, barangCategorySelectedError: 'Pilih Kategori Barang Terlebih Dahulu.' } }))
        } else if (validator.isEmpty(data.editBarang.barangName, { ignore_whitespace: true })) {
            setData(d => ({ ...d, editBarang: { ...d.editBarang, barangNameError: 'Nama Barang Wajib Diisi.' } }))
        } else if (isEmptyArrayObject(data.editBarang.kelengkapan, 'delivery_jemput_kelengkapan_actual_name')) {
            setData(d => ({ ...d, barang: { ...d.barang, kelengkapanError: 'Lengkapi list kelengkapan terlebih dahulu atau hapus item yang kosong!' } }))
        } else {
            setData(d => ({ ...d, editBarang: { ...d.editBarang, submitLoading: true } }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('master_id', data.editBarang.masterId);
            formDT.append('current_step', utilsRef.currentStep);
            formDT.append('is_cancel', utilsRef.isCancel);

            formDT.append('primary_key_id', data.editBarang.primaryKeyId);
            formDT.append('barang_category', data.editBarang.barangCategorySelected);
            formDT.append('barang_name', data.editBarang.barangName);
            formDT.append('barang_keluhan', data.editBarang.keluhan);
            formDT.append('barang_kelengkapan_array', JSON.stringify(data.editBarang.kelengkapan));

            axios({
                method: 'post',
                url: BE_API_THREE + '/update_delivery_penjemputan__barang_actual',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, editBarang: { ...d.editBarang, submitLoading: false, modal: false } }));

                if (response.data.flag_status === 'isset') {
                    fnBarang(data.editBarang.stateKey, 'barang', response.data.data);

                    setData(d => ({
                        ...d,
                        editBarang: {
                            ...d.editBarang,
                            masterId: '',
                            stateKey: '',
                            primaryKeyId: '',

                            barangCategorySelected: '',
                            barangName: '',

                            suggestData: [],
                            suggestSelected: '',

                            keluhan: '',
                            kelengkapan: [],
                        },
                    }))
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorBarang,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data') {
                    // fnCloseDrawer();

                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data tidak ditemukan.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, editBarang: { ...d.editBarang, submitLoading: false, modal: false } }));

                notifications.show({
                    id: notificationId.current.errorBarang,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }

    const ModalSuggestNamaBarang = ({
        stateData,
        fnShowModal,
        fnSetNamaBarang,
        fnOnChangeSelector
    }) => {
        return (
            <ModalTakeActionWithFooterWhenHasData
                stateHasData={(Array.isArray(stateData.suggestData) && (stateData.suggestData.length > 0)) ? true : false}
                stateShow={stateData.suggestModal}
                fnHide={() => fnShowModal(false)}

                stateHideOnClickOutSide={true}
                stateTitle={String('History Nama Barang').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Pilih'
                stateButtonActionPx='md'
                stateButtonActionColor="blue"
                stateButtonActionLoading={false}
                fnButtonAction={() => fnSetNamaBarang()}
            >
                {stateData.suggestLoadingInit &&
                    <Text size='sm' color="dimmed" py='.475rem'>Loading Data History Barang..</Text>
                }

                {!stateData.suggestLoadingInit && Array.isArray(stateData.suggestData) && (stateData.suggestData.length > 0) &&
                    <NativeSelect
                        value={stateData.suggestSelected}
                        onChange={(e) => fnOnChangeSelector(e)}
                        data={[
                            { value: '', label: 'Pilih Nama Barang' },
                            ...stateData.suggestData.map(key => ({ value: key.barang_nama, label: key.barang_nama })),
                        ]}
                    />
                }

                {!stateData.suggestLoadingInit && Array.isArray(stateData.suggestData) && (stateData.suggestData.length <= 0) &&
                    <React.Fragment>
                        <Text size='sm' color="dimmed" py='.475rem'>Tidak ada history barang.</Text>
                    </React.Fragment>
                }
            </ModalTakeActionWithFooterWhenHasData>
        )
    }

    const submitDeleteBarang = () => {
        setData(d => ({ ...d, deleteBarang: { ...d.deleteBarang, submitLoading: true } }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('trx_id', data.deleteBarang.trxId);
        formDT.append('current_step', utilsRef.currentStep);
        formDT.append('is_cancel', utilsRef.isCancel);

        formDT.append('primary_key_id', data.deleteBarang.primaryKeyId);

        axios({
            method: 'post',
            url: BE_API_THREE + '/delete_delivery_penjemputan__barang_actual',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, deleteBarang: { ...d.deleteBarang, submitLoading: false, modal: false } }));

            if (response.data.flag_status === 'isset') {
                fnBarangDelete(data.deleteBarang.stateKey, 'barang', response.data.data);

                setData(d => ({
                    ...d,
                    deleteBarang: {
                        ...d.deleteBarang,
                        trxId: '',
                        stateKey: '',
                        primaryKeyId: '',
                    },
                }))
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorBarangDelete,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                fnCloseDrawer();

                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, deleteBarang: { ...d.deleteBarang, submitLoading: false, modal: false } }));

            notifications.show({
                id: notificationId.current.errorBarangDelete,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel='Daftar Barang Untuk Dijemput'
                stateWithAsterisk={true}
                stateError=''
                stateDescription=''
            // stateMB="2rem"
            >
                {Array.isArray(dataDataKey.barang) && (dataDataKey.barang.length > 0) ?
                    Object.keys(dataDataKey.barang).map((keyB, indexB) => {
                        return (
                            <PaperWrapper key={keyB} stateMB=".5rem">
                                <Flex
                                    wrap='nowrap'
                                    gap="sm"
                                    justify="flex-start"
                                    align="flex-start"
                                >
                                    <Text size='sm'>
                                        {Number(indexB) + 1}.
                                    </Text>

                                    {/* suspect flex: 1 atau width: '100%' atau flexGrow: 1 */}
                                    <Box sx={{ flex: 1 }}>
                                        <Group
                                            spacing='xs'
                                            noWrap
                                            position='apart'
                                            align='flex-start'
                                        >
                                            <Text size='sm'>
                                                Kategori : {safeValue(dataDataKey.barang[keyB].barang_category_name, '[Kategori Barang]')}
                                            </Text>

                                            {canEditBarangActual.current.includes(utilsRef.currentStep) &&
                                                <Menu shadow="md" width={150}>
                                                    <Menu.Target>
                                                        <ActionIcon
                                                            size='md'
                                                            variant="subtle"
                                                            radius='xl'

                                                            sx={(tema) => ({
                                                                backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[1] : tema.colors.dark[5],
                                                                '&:hover': {
                                                                    backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[2] : tema.colors.dark[4]
                                                                },
                                                            })}
                                                        >
                                                            <IconDotsVertical size='1rem' />
                                                        </ActionIcon>
                                                    </Menu.Target>

                                                    <Menu.Dropdown>
                                                        <Menu.Item
                                                            onClick={() => {
                                                                setData(d => ({
                                                                    ...d,
                                                                    editBarang: {
                                                                        ...d.editBarang,
                                                                        masterId: dataDataKey.delivery_jemput_id,
                                                                        primaryKeyId: dataDataKey.barang[keyB].delivery_jemput_barang_actual_id,
                                                                        stateKey: stateKey,
                                                                        barangCategorySelected: safeValue(dataDataKey.barang[keyB].barang_category_id, ''),

                                                                        barangName: dataDataKey.barang[keyB].delivery_jemput_barang_actual_name,

                                                                        kelengkapan: safeValue(dataDataKey.barang[keyB].kelengkapan, []),

                                                                        keluhan: dataDataKey.barang[keyB].delivery_jemput_barang_actual_keluhan,

                                                                        modal: true
                                                                    }
                                                                }))
                                                            }}
                                                        >
                                                            Edit Barang
                                                        </Menu.Item>

                                                        <Menu.Item
                                                            onClick={() => {
                                                                setData(d => ({
                                                                    ...d,
                                                                    deleteBarang: {
                                                                        ...d.deleteBarang,
                                                                        trxId: dataDataKey.delivery_jemput_id,
                                                                        primaryKeyId: dataDataKey.barang[keyB].delivery_jemput_barang_actual_id,
                                                                        stateKey: stateKey,
                                                                        modal: true
                                                                    }
                                                                }))
                                                            }}
                                                        >
                                                            Delete
                                                        </Menu.Item>
                                                    </Menu.Dropdown>
                                                </Menu>
                                            }
                                        </Group>

                                        <Divider variant="dashed" my='.5rem' />

                                        <Text size='sm'>
                                            Item : {dataDataKey.barang[keyB].delivery_jemput_barang_actual_name}
                                        </Text>

                                        <Divider variant="dashed" my='.5rem' />

                                        <Text size='sm'>
                                            Keluhan : {safeValue(dataDataKey.barang[keyB].delivery_jemput_barang_actual_keluhan, ' - ')}
                                        </Text>

                                        <Divider variant="dashed" my='.5rem' />

                                        <Text size='sm'>
                                            Kelengkapan : {arrayObjectToStringWithDivider(dataDataKey.barang[keyB].kelengkapan, 'delivery_jemput_kelengkapan_actual_name', ', ', ' - ')}
                                        </Text>

                                        <Divider variant="dashed" my='.5rem' />

                                        <Text size='sm'>
                                            <SedangJemputFoto
                                                dataDataKey={dataDataKey.barang[keyB].foto}
                                                stateData={{
                                                    trxId: dataDataKey.delivery_jemput_id,
                                                    primaryKeyId: dataDataKey.barang[keyB].delivery_jemput_barang_actual_id,
                                                    currentStep: utilsRef.currentStep,
                                                    isCancel: utilsRef.isCancel
                                                }}

                                                fnOnChange={(dataArrayBarang) => {
                                                    fnChangeFoto(stateKey, 'barang', dataArrayBarang);
                                                }}
                                                fnClickPhoto={fnClickPhoto}
                                            />
                                        </Text>
                                    </Box>
                                </Flex>
                            </PaperWrapper>
                        )
                    })
                    :
                    <PaperWrapper>
                        <Text size='sm'>Belum ada daftar barang.</Text>
                    </PaperWrapper>
                }

                {canEditBarangActual.current.includes(utilsRef.currentStep) &&
                    <Group
                        spacing={5}
                        px='xs'
                        py='0.25rem'
                        mt='md'
                        position="center"

                        sx={(tema) => ({
                            borderWidth: '1px',
                            borderStyle: 'dashed',
                            borderColor: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                            borderRadius: tema.radius.sm,
                            color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                            cursor: 'pointer',
                            '&:hover': {
                                backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
                            }
                        })}

                        onClick={() => setData(d => ({
                            ...d,
                            barang: { ...d.barang, masterId: dataDataKey.delivery_jemput_id, stateKey: stateKey, barangModal: true }
                        }))}
                    >
                        <IconPlus size='0.8rem' />
                        <Text size='sm'>Tambah Barang</Text>
                    </Group>
                }
            </InputWrapperCustom>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.barang.barangModal}
                fnHide={() => setData(d => ({ ...d, barang: { ...d.barang, barangModal: false } }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Tambah Barang').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.barang.barangLoadingSubmit}
                fnButtonAction={submitTambahBarang}
            >
                <InputWrapperCustom
                    stateLabel='Kategori Barang'
                    stateWithAsterisk={false}
                    stateError=''
                    stateDescription=''

                    stateMT="1rem"
                    stateMB="1.5rem"
                >
                    <Select
                        value={safeValue(data.barang.barangCategorySelected, '')}
                        error={data.barang.barangCategorySelectedError}
                        onChange={(val) => setData(d => ({ ...d, barang: { ...d.barang, barangCategorySelected: val } }))}
                        data={[
                            { value: '', label: 'Pilih Kategori Barang' },
                            ...dataCategoryBarang.map(key => ({ value: key.barang_category_id, label: key.barang_category_name }))
                        ]}
                    />
                </InputWrapperCustom>

                <InputComponent
                    stateId='barang-add-deivery-jemput-1'
                    stateWithAsterisk={false}
                    stateLabelFullWidth={true}
                    stateLabel={
                        <Group spacing={6} position='apart'>
                            <Text>Nama Barang</Text>

                            {(Array.isArray(data.barang.suggestData) && (data.barang.suggestData.length > 0)) &&
                                <Text
                                    color="blue"
                                    fw='normal'
                                    td='underline'
                                    sx={{
                                        cursor: 'pointer'
                                    }}

                                    onClick={(e) => {
                                        e.preventDefault();
                                        setData(d => ({ ...d, barang: { ...d.barang, suggestModal: true } }));
                                    }}
                                >
                                    History Nama
                                </Text>
                            }
                        </Group>
                    }
                    stateDescription=''
                    statePlaceHolder='Nama Barang'
                    stateReadOnly={false}
                    stateValue={data.barang.barangName}
                    stateError={data.barang.barangNameError}
                    stateMB="1rem"
                    fnOnChange={(e) => setData(d => ({ ...d, barang: { ...d.barang, barangName: e.target.value } }))}
                />

                <Textarea
                    value={data.barang.keluhan}
                    minRows={3}
                    maxRows={4}
                    onChange={(e) => setData(d => ({ ...d, barang: { ...d.barang, keluhan: e.target.value } }))}

                    mb='1rem'
                    label='Keluhan'
                    placeholder='Kerusakan/Keluhan'
                    error=''
                    description=''
                    withAsterisk={false}
                />

                <InputWrapperCustom
                    stateLabel='Kelengkapan Barang'
                    stateWithAsterisk={false}
                    stateError={data.barang.kelengkapanError}
                    stateDescription=''
                    stateMB=".5rem"
                >
                    {Array.isArray(data.barang.kelengkapan) && (data.barang.kelengkapan.length > 0) &&
                        Object.keys(data.barang.kelengkapan).map((keyKL, indexKL) => {
                            return (
                                <TextInput
                                    key={keyKL}
                                    mb='.5rem'
                                    placeholder='Kelengkapan'
                                    rightSection={
                                        <IconX
                                            size='0.8rem'
                                            style={{ cursor: 'pointer' }}

                                            onClick={() => {
                                                setData(d => ({
                                                    ...d,
                                                    barang: {
                                                        ...d.barang,
                                                        kelengkapan: removeFromArrayByIndex(keyKL, d.barang.kelengkapan)
                                                    }
                                                }))
                                            }}
                                        />
                                    }
                                    value={data.barang.kelengkapan[keyKL].name}
                                    onChange={(e) => {
                                        setData(d => ({
                                            ...d,
                                            barang: {
                                                ...d.barang,
                                                kelengkapan: changeValueOfArrayImmutable(d.barang.kelengkapan, keyKL, 'name', e.target.value)
                                            }
                                        }))
                                    }}
                                />
                            )
                        })
                    }

                    <Group
                        spacing={5}
                        px='xs'
                        py='0.25rem'
                        mt='md'
                        position="center"

                        sx={(tema) => ({
                            borderWidth: '1px',
                            borderStyle: 'dashed',
                            borderColor: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                            borderRadius: tema.radius.sm,
                            color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                            cursor: 'pointer',
                            '&:hover': {
                                backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
                            }
                        })}

                        onClick={() => setData(d => ({
                            ...d,
                            barang: { ...d.barang, kelengkapan: [...d.barang.kelengkapan, constKelengkapan] }
                        }))}
                    >
                        <IconPlus size='0.8rem' />
                        <Text size='sm'>Tambah Kelengkapan Barang</Text>
                    </Group>
                </InputWrapperCustom>
            </ModalTakeAction>

            <ModalTakeAction
                stateShow={data.editBarang.modal}
                fnHide={() => setData(d => ({ ...d, editBarang: { ...d.editBarang, modal: false } }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Update Barang').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.editBarang.submitLoading}
                fnButtonAction={submitUpdateBarang}
            >
                <InputWrapperCustom
                    stateLabel='Kategori Barang'
                    stateWithAsterisk={false}
                    stateError=''
                    stateDescription=''

                    stateMT="1rem"
                    stateMB="1.5rem"
                >
                    <Select
                        value={safeValue(data.editBarang.barangCategorySelected, '')}
                        error={data.editBarang.barangCategorySelectedError}
                        onChange={(val) => setData(d => ({ ...d, editBarang: { ...d.editBarang, barangCategorySelected: val } }))}
                        data={[
                            { value: '', label: 'Pilih Kategori Barang' },
                            ...dataCategoryBarang.map(key => ({ value: key.barang_category_id, label: key.barang_category_name }))
                        ]}
                    />
                </InputWrapperCustom>

                <InputComponent
                    stateId='barang-update-deivery-jemput-1'
                    stateWithAsterisk={false}
                    stateLabelFullWidth={true}
                    stateLabel={
                        <Group spacing={6} position='apart'>
                            <Text>Nama Barang</Text>

                            {(Array.isArray(data.barang.suggestData) && (data.barang.suggestData.length > 0)) &&
                                <Text
                                    color="blue"
                                    fw='normal'
                                    td='underline'
                                    sx={{
                                        cursor: 'pointer'
                                    }}

                                    onClick={(e) => {
                                        e.preventDefault();
                                        setData(d => ({ ...d, editBarang: { ...d.editBarang, suggestModal: true } }));
                                    }}
                                >
                                    History Nama
                                </Text>
                            }
                        </Group>
                    }
                    stateDescription=''
                    statePlaceHolder='Nama Barang'
                    stateReadOnly={false}
                    stateValue={safeValue(data.editBarang.barangName, '')}
                    stateError={data.editBarang.barangNameError}
                    stateMB="1rem"
                    fnOnChange={(e) => setData(d => ({ ...d, editBarang: { ...d.editBarang, barangName: e.target.value } }))}
                />

                <Textarea
                    value={safeValue(data.editBarang.keluhan, '')}
                    minRows={3}
                    maxRows={4}
                    onChange={(e) => setData(d => ({ ...d, editBarang: { ...d.editBarang, keluhan: e.target.value } }))}

                    mb='1rem'
                    label='Keluhan'
                    placeholder='Kerusakan/Keluhan'
                    error=''
                    description=''
                    withAsterisk={false}
                />

                <InputWrapperCustom
                    stateLabel='Kelengkapan Barang'
                    stateWithAsterisk={false}
                    stateError={data.editBarang.kelengkapanError}
                    stateDescription=''
                    stateMB=".5rem"
                >
                    {Array.isArray(data.editBarang.kelengkapan) && (data.editBarang.kelengkapan.length > 0) &&
                        Object.keys(data.editBarang.kelengkapan).map((keyKL, indexKL) => {
                            return (
                                <TextInput
                                    key={keyKL}
                                    mb='.5rem'
                                    placeholder='Kelengkapan'
                                    rightSection={
                                        <IconX
                                            size='0.8rem'
                                            style={{ cursor: 'pointer' }}

                                            onClick={() => {
                                                setData(d => ({
                                                    ...d,
                                                    editBarang: {
                                                        ...d.editBarang,
                                                        kelengkapan: removeFromArrayByIndex(keyKL, d.editBarang.kelengkapan)
                                                    }
                                                }))
                                            }}
                                        />
                                    }
                                    value={data.editBarang.kelengkapan[keyKL].delivery_jemput_kelengkapan_actual_name}
                                    onChange={(e) => {
                                        setData(d => ({
                                            ...d,
                                            editBarang: {
                                                ...d.editBarang,
                                                kelengkapan: changeValueOfArrayImmutable(d.editBarang.kelengkapan, keyKL, 'delivery_jemput_kelengkapan_actual_name', e.target.value)
                                            }
                                        }))
                                    }}
                                />
                            )
                        })
                    }

                    <Group
                        spacing={5}
                        px='xs'
                        py='0.25rem'
                        mt='md'
                        position="center"

                        sx={(tema) => ({
                            borderWidth: '1px',
                            borderStyle: 'dashed',
                            borderColor: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                            borderRadius: tema.radius.sm,
                            color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                            cursor: 'pointer',
                            '&:hover': {
                                backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
                            }
                        })}

                        onClick={() => setData(d => ({
                            ...d,
                            editBarang: { ...d.editBarang, kelengkapan: [...d.editBarang.kelengkapan, constKelengkapanEdit] }
                        }))}
                    >
                        <IconPlus size='0.8rem' />
                        <Text size='sm'>Tambah Kelengkapan Barang</Text>
                    </Group>
                </InputWrapperCustom>
            </ModalTakeAction>

            <ModalSuggestNamaBarang
                stateData={{
                    suggestData: data.barang.suggestData,
                    suggestModal: data.barang.suggestModal,
                    suggestLoadingInit: data.barang.suggestLoadingInit,
                    suggestSelected: data.barang.suggestSelected
                }}
                fnShowModal={(val) => setData(d => ({ ...d, barang: { ...d.barang, suggestModal: val } }))}
                fnSetNamaBarang={() => {
                    setData(d => ({ ...d, barang: { ...d.barang, barangName: d.barang.suggestSelected, suggestModal: false } }))
                }}
                fnOnChangeSelector={(e) => {
                    setData(d => ({ ...d, barang: { ...d.barang, suggestSelected: e.target.value } }))
                }}
            />

            <ModalSuggestNamaBarang
                stateData={{
                    suggestData: data.editBarang.suggestData,
                    suggestModal: data.editBarang.suggestModal,
                    suggestLoadingInit: data.editBarang.suggestLoadingInit,
                    suggestSelected: data.editBarang.suggestSelected
                }}
                fnShowModal={(val) => setData(d => ({ ...d, editBarang: { ...d.editBarang, suggestModal: val } }))}
                fnSetNamaBarang={() => {
                    setData(d => ({ ...d, editBarang: { ...d.editBarang, barangName: d.editBarang.suggestSelected, suggestModal: false } }))
                }}
                fnOnChangeSelector={(e) => {
                    setData(d => ({ ...d, editBarang: { ...d.editBarang, suggestSelected: e.target.value } }))
                }}
            />

            <ModalTakeAction
                stateShow={data.deleteBarang.modal}
                fnHide={() => setData(d => ({ ...d, deleteBarang: { ...d.deleteBarang, modal: false } }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Hapus'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.deleteBarang.submitLoading}
                fnButtonAction={submitDeleteBarang}
            >
                <Text size='sm' color="dimmed">Hapus Item Ini ?</Text>
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default ComponentBarangActual;